export default __webpack_public_path__ + "static/media/upload-file.d16945f5.svg";